import { KotlinLoggingConfiguration_getInstance1qkm2mkxywgav as KotlinLoggingConfiguration_getInstance } from './KotlinLoggingConfiguration.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KotlinLoggingClass;
function KotlinLogging() {
  if (KotlinLoggingClass === VOID) {
    class $ {
      constructor() {
        KotlinLogging_instance = this;
        var factory = KotlinLoggingConfiguration_getInstance().f2f_1;
        if (KotlinLoggingConfiguration_getInstance().d2f_1) {
          println('kotlin-logging: initializing... active logger factory: ' + getKClassFromExpression(factory).j1());
        }
      }
      i2f(name) {
        return KotlinLoggingConfiguration_getInstance().f2f_1.i2f(name);
      }
    }
    initMetadataForObject($, 'KotlinLogging');
    KotlinLoggingClass = $;
  }
  return KotlinLoggingClass;
}
var KotlinLogging_instance;
function KotlinLogging_getInstance() {
  if (KotlinLogging_instance === VOID)
    new (KotlinLogging())();
  return KotlinLogging_instance;
}
//region block: exports
export {
  KotlinLogging_getInstance as KotlinLogging_getInstance36i5tmdcg9bhr,
};
//endregion

//# sourceMappingURL=KotlinLogging.mjs.map
